import { useEffect, useState } from "react";

import { PRINTING_GANTT_CLASS } from "@/modules/export/print-view";

function isPrintingGantt(): boolean {
  return document.documentElement.classList.contains(PRINTING_GANTT_CLASS);
}

function readMatches(query: string): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  // O diálogo de impressão encolhe o viewport: sem isso o Gantt troca para o
  // layout mobile e, ao fechar, as colunas ficam desalinhadas.
  if (isPrintingGantt() && /max-width/i.test(query)) return false;

  return window.matchMedia(query).matches;
}

/**
 * Acompanha uma media query do CSS para as decisões que a folha de estilo não
 * resolve sozinha — na Tela Inicial, deixar de oferecer a Visão Geral na versão
 * responsiva (RN07), e não apenas escondê-la visualmente.
 *
 * Sem `matchMedia` disponível devolve `false`, ou seja, a versão Desktop.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => readMatches(query));

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;

    const list = window.matchMedia(query);

    function sync() {
      setMatches(readMatches(query));
    }

    sync();
    list.addEventListener("change", sync);
    const observer = new MutationObserver(sync);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });

    return () => {
      list.removeEventListener("change", sync);
      observer.disconnect();
    };
  }, [query]);

  return matches;
}
